import Qs from "qs";
import index from "./index";

/**
 * 获取文言列表
 * @param {*} service
 */
function getServicesText(service) {
  return index[service];
}

/**
 * 获取异常case文言提示
 * @param {*} services
 * @param {*} data
 */
function next(services, data) {
  return getServicesText(services)
    ? getServicesText(services)[data.respCode] || ""
    : "";
}
/**
 * 请求拦截器处理
 * @param {*} config
 */
function requestInterceptors(config) {
  if (config.method !== "get") {
    if (config.headers["Content-Type"].indexOf("application/json") > -1) {
      config.data = JSON.stringify(config.data);
    } else if (
      config.headers["Content-Type"].indexOf("multipart/form-data") > -1
    ) {
      let data = new FormData();

      for (let key of Object.keys(config.data)) {
        data.append(key, config.data[key]);
      }
      config.data = data;
    } else {
      config.data = Qs.stringify(config.data);
    }
  }
  return config;
}

export default {
  next,
  requestInterceptors
};
